import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, of, throwError } from 'rxjs';
import { inject } from '@angular/core';
import { keyValueInTextMatcher, NavigationUtils } from '@ipensii/shared/util-shared';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppPath } from '@ipensii/shared/domain-shared';
import { CacheService } from '../cache.service';

const INVALID_TOKEN_ERROR = 'invalid_token';
const RESUME_PATHS = [AppPath.fund];

export const httpClientErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const cacheService = inject(CacheService);
  const messageService = inject(MessageService);
  const parse: <T>(error: string | T) => T = (error) => {
    if (error) {
      if (typeof error === 'string') {
        return JSON.parse(error);
      }
    }
    return error;
  };

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (!err.status) {
        return of(); // firefox throws an error if the request is canceled, we need to ignore it
      }
      const errHeader = err.headers.get('Www-Authenticate')?.match(keyValueInTextMatcher('error'));
      const error = errHeader && errHeader[1];
      const desc = parse(err.error)?.description;
      if (err.status === 401 && error === INVALID_TOKEN_ERROR) {
        cacheService.clear();
        NavigationUtils.clearQueryParams(router.url) === '/'
          ? location.reload()
          : router.navigate(['/'], { onSameUrlNavigation: 'reload' });
      } else {
        messageService.add({ summary: desc || 'A avut loc o eroare, vă rugăm reîncercați!', severity: 'error' });
      }
      return throwError(() => err);
    })
  );
};
